import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/wx.png'
import _imports_1 from '../assets/zfb.png'
import _imports_2 from '../assets/kfIcon.png'


const _withScopeId = n => (_pushScopeId("data-v-37f9f4e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"color":"#333333"} }, "还没有收货地址，去添加一个吧", -1))
const _hoisted_4 = { class: "nameOrphone" }
const _hoisted_5 = { class: "address" }
const _hoisted_6 = { class: "product-container" }
const _hoisted_7 = { class: "name" }
const _hoisted_8 = { class: "tag" }
const _hoisted_9 = { class: "select" }
const _hoisted_10 = { class: "price" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_12 = { class: "quantity" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 购买数量 ")
const _hoisted_14 = { class: "other" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "otherField" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "label" }, "配送方式"),
  /*#__PURE__*/_createElementVNode("span", { class: "value" }, "普通快递包邮")
], -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "支付方式", -1))
const _hoisted_17 = { class: "value" }
const _hoisted_18 = {
  key: 0,
  src: _imports_0,
  style: {"height":"0.32rem","margin-right":"0.05rem"},
  alt: ""
}
const _hoisted_19 = {
  key: 1,
  src: _imports_1,
  style: {"height":"0.32rem","margin-right":"0.05rem"},
  alt: ""
}
const _hoisted_20 = { class: "order-notes" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "label" }, "订单备注", -1))
const _hoisted_22 = { class: "payContent" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "pTitle" }, "请选择支付方式", -1))
const _hoisted_24 = { class: "payList" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = {
  key: 0,
  src: _imports_0,
  alt: ""
}
const _hoisted_27 = {
  key: 1,
  src: _imports_1,
  alt: ""
}
const _hoisted_28 = { class: "footer" }
const _hoisted_29 = { class: "footContent" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "kfIcon",
  src: _imports_2,
  alt: ""
}, null, -1))
const _hoisted_31 = /*#__PURE__*/_createTextVNode(" 客服 ")
const _hoisted_32 = [
  _hoisted_30,
  _hoisted_31
]
const _hoisted_33 = { class: "flex" }
const _hoisted_34 = /*#__PURE__*/_createTextVNode(" 合计: ")
const _hoisted_35 = { class: "price" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"font-size":"0.24rem"} }, "￥", -1))
const _hoisted_37 = /*#__PURE__*/_createTextVNode("立即购买")

import {
  NavBar,
  Icon,
  Divider,
  Stepper,
  Field,
  Popup,
  Dialog,
  Button,
  Toast,
} from "vant";
import router from "@/router";
import { computed, onMounted, ref, inject } from "vue";
import { useRoute } from "vue-router";
import AddAddress from "./Address.vue";
import pingpp from "pingpp-js";
import Request, { request } from "@/provide/fetch";

export default /*#__PURE__*/_defineComponent({
  name: 'submitOrder',
  setup(__props) {

const route = useRoute();
const goodeId = route.query.id;
const activeFlowType = route.query.activeFlowType;
const activeFlowGear = route.query.activeFlowGear;
const activeFate = route.query.activeFate;
const userIP = ref("");
const quantity = ref(1);
onMounted(async () => {
  const res = await fetch(
    "https://api.ipdatacloud.com/v2/query?key=c8c66dfe141411ef81f700163e167ffb"
  );
  const data = await res.json();
  console.log(data);
  if (data.code === 500) {
    handleV6IP();
  } else {
    userIP.value = data.data.location.ip;
  }
});
const handleV6IP = async () => {
  const resp = await fetch(
    "https://api.ipdatacloud.com/v2/query?key=ff3ef544425c11ef98e000163e167ffb"
  );
  const data = await resp.json();
  userIP.value = data.data.location.ip;
};
const goodvalue = ref({});
request({
  url: `/product/get-child-product`,
  method: "POST",
  data: {
    flowLevel: activeFlowGear,
    selectDays: activeFate,
    flowType: activeFlowType,
    productId: Number(goodeId),
  },
})
  .then((res) => {
    goodvalue.value = res.data;
  })
  .catch(() => {
    Toast("网络错误，请稍后重试");
  });
const payType = ref("wx");
const copyPayType = ref("wx");
const payTypeList = ref(["wx", "zfb"]);
const remarks = ref("");
const payTypeShow = ref(false);
const total = computed(() => {
  return (quantity.value * goodvalue.value.productPrice || 0).toFixed(2);
});
const addressShow = ref(false);
const saveLoading = ref(false);
// /card-order/pay
const handleSubmit = () => {
  // 保存订单
  if (!addressObject.value?.addressId) return Toast("请选择收货地址");
  saveLoading.value = true;
  Request({
    url: "/order/save",
    method: "POST",
    data: {
      addressId: addressObject.value.addressId,
      productCode: route.query.productCode,
      buyCount: quantity.value,
      deliveryType: "普通快递包邮",
      payType: payType.value == "wx" ? 1 : 2,
      payPrice: (total.value * 10000) / 100,
      orderComment: remarks.value,
    },
  })
    .then((resp: any) => {
      if (resp.code === 200) {
        saveLoading.value = true;
        const data = {
          orderId: resp.data,
          payType: payType.value == "wx" ? 1 : 2,
          price: (total.value * 10000) / 100,
          clientIp: userIP.value,
        };
        Request({
          url: "/card-order/pay",
          method: "POST",
          data: data,
        })
          .then((res) => {
            console.log(res);
            // pingpp.setAPURL('//international-card-h5.mobilecn.net/pay.htm');
            pingpp.createPayment(res.data, (result, err) => {
              console.log(result);
              if (result == "success") {
                console.log("success");
              } else {
                console.log("失败");
                router.push({
                  path: "/OrderPage",
                });
              }
            });
          })
          .finally(() => {
            saveLoading.value = false;
          });
      }
    })
    .finally(() => {
      saveLoading.value = false;
    });
};
const handleChangeAddress = (value: any) => {
  addressShow.value = false;
};
const addressObject = ref({});
const handleSelectAddress = (value: any) => {
  addressShow.value = false;
  addressObject.value = value;
  isShowAdress.value = true;
};
// 客服
const kfshow = ref(false);
const handleKfConfirm = () => {
  // kfshow.value = false;
  window.location.href = "tel:010-63589500";
};
const handleShowCustomerService = inject("handleShowCustomerService") as () => void;
const handleKf = () => {
  handleShowCustomerService();
};
const isShowAdress = ref(false);
const handleGetDefaultAddress = async () => {
  const res = await request({
    url: "/order/address/page",
    method: "POST",
    data: {
      searchOption: {
        isDefault: 1,
      },
      pageParam: { current: 1, size: 100 },
    },
  });
  if (res.code === 200) {
    addressObject.value = res.data.records[0];
    isShowAdress.value = res.data.records.length > 0;
  }
};
handleGetDefaultAddress();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(NavBar), {
      title: "确认订单",
      "left-arrow": "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).go(-1)))
    }),
    _createElementVNode("div", _hoisted_2, [
      (!isShowAdress.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "address-container",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (addressShow.value = true))
          }, [
            _hoisted_3,
            _createVNode(_unref(Icon), { name: "arrow" })
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 1,
            onClick: _cache[2] || (_cache[2] = ($event: any) => (addressShow.value = true)),
            class: "address-container"
          }, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("span", null, _toDisplayString(addressObject.value.userName), 1),
                _createElementVNode("span", null, _toDisplayString(addressObject.value.phone), 1)
              ]),
              _createElementVNode("div", _hoisted_5, _toDisplayString(addressObject.value.province) + " " + _toDisplayString(addressObject.value.city) + " " + _toDisplayString(addressObject.value.country) + " " + _toDisplayString(addressObject.value.detailAddress), 1)
            ]),
            _createVNode(_unref(Icon), { name: "arrow" })
          ])),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(goodvalue.value.productName), 1),
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(goodvalue.value.productSellPoints, (item) => {
            return (_openBlock(), _createElementBlock("span", {
              key: item,
              class: "tagItem"
            }, _toDisplayString(item), 1))
          }), 128))
        ]),
        _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(activeFlowGear)) + " × " + _toDisplayString(_unref(activeFate)), 1),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(_toDisplayString(goodvalue.value.productPrice), 1)
        ]),
        _createVNode(_unref(Divider), { style: {"margin":"0.12rem 0"} }),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createVNode(_unref(Stepper), {
            modelValue: quantity.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((quantity).value = $event)),
            min: 0
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _hoisted_15,
        _createElementVNode("div", {
          class: "otherField",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (payTypeShow.value = true))
        }, [
          _hoisted_16,
          _createElementVNode("span", _hoisted_17, [
            (payType.value == 'wx')
              ? (_openBlock(), _createElementBlock("img", _hoisted_18))
              : _createCommentVNode("", true),
            (payType.value == 'zfb')
              ? (_openBlock(), _createElementBlock("img", _hoisted_19))
              : _createCommentVNode("", true),
            _createVNode(_unref(Icon), { name: "arrow" })
          ])
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createVNode(_unref(Field), {
            class: "textarea",
            placeholder: "如有备注请填写",
            modelValue: remarks.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((remarks).value = $event)),
            rows: "2",
            type: "textarea"
          }, null, 8, ["modelValue"])
        ])
      ]),
      _createVNode(_unref(Popup), {
        show: payTypeShow.value,
        "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((payTypeShow).value = $event)),
        round: "",
        position: "bottom",
        style: { height: '30%' }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_22, [
            _hoisted_23,
            _createElementVNode("div", _hoisted_24, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(payTypeList.value, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item,
                  class: _normalizeClass(["payItem", { activePay: item === copyPayType.value }]),
                  onClick: ($event: any) => (copyPayType.value = item)
                }, [
                  (item === 'wx')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_26))
                    : _createCommentVNode("", true),
                  (item === 'zfb')
                    ? (_openBlock(), _createElementBlock("img", _hoisted_27))
                    : _createCommentVNode("", true)
                ], 10, _hoisted_25))
              }), 128))
            ]),
            _createElementVNode("div", {
              class: "payBtn",
              onClick: _cache[6] || (_cache[6] = ($event: any) => ((payTypeShow.value = false), (payType.value = copyPayType.value)))
            }, " 确认 ")
          ])
        ]),
        _: 1
      }, 8, ["show"]),
      _createVNode(_unref(Popup), {
        show: addressShow.value,
        "onUpdate:show": _cache[8] || (_cache[8] = ($event: any) => ((addressShow).value = $event)),
        position: "right",
        style: { width: '100%', height: '100%' }
      }, {
        default: _withCtx(() => [
          _createVNode(AddAddress, {
            type: "submitOrder",
            onChange: handleChangeAddress,
            onSelect: handleSelectAddress
          })
        ]),
        _: 1
      }, 8, ["show"])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", {
          class: "kf",
          onClick: handleKf
        }, _hoisted_32),
        _createElementVNode("div", _hoisted_33, [
          _hoisted_34,
          _createElementVNode("div", _hoisted_35, [
            _hoisted_36,
            _createTextVNode(_toDisplayString(_unref(total)), 1)
          ])
        ]),
        _createVNode(_unref(Button), {
          loading: saveLoading.value,
          class: "submitBtn",
          onClick: handleSubmit
        }, {
          default: _withCtx(() => [
            _hoisted_37
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ])
  ]))
}
}

})